import type {
  LeadListResponse,
  ReferralBusinessResponse,
  ReferralPayload,
  ReferralUserListResponse,
} from "@/types/ReferralProgramtype";
import { privateRequest, referralRequest, type ApiResponse } from "../axios";
import { saveAsExcelFile } from "../excelService/excelSevice";

export interface Country {
  CountryId: number;
  Name: string;
  CountryCode: string;
}
export interface State {
  StateId: number;
  Name: string;
}

export interface City {
  CityId: number;
  Name: string;
}

const ENDPOINTS = {
  MY_REFERRALS: "referral/ReferralUser/ReferralUsers",
  MY_REFERRAL_DETAIL_BY_ID: (id: number) => `referral/ReferralUser/${id}`,
  MY_REFERRAL_DELETE: (id: number) => `/referral/ReferralUser/${id}`,
  COUNTRY_LIST: `api/GetCountryList`,
  STATE_LIST: (countryId: any) => `api/GetStateList/?CountryId=${countryId}`,
  CITY_LIST: (stateId: number) => `api/GetCityList?StateId=${stateId}`,
  UPDATE_REFRRAL: (referralId: number) => `referral/ReferralUser/ReferralUser/${referralId}`,
  ADD_REFRRAL: `referral/ReferralUser/ReferralUser`,
  APPROVE_REFERRAL: (userId: number) => `referral/ReferralUser/${userId}/Status`,
  EXPORT_REFERRAL: `/referral/ReferralUser/Export`,
  REFERRAL_BUSINESS: "referral/ReferralBusiness/ReferralBusinessess/Count",
  LEADS: "api/CRM/Leads",
  REFERRAL_USER_LIST: "/referral/ReferralUser/ApprovedReferralUsers",
  ACCEPT_REJECT_STATUS: (id: number) => `referral/ReferralBusiness/${id}/Status`,
  DELETE_BUSINESS_REFERRAL: (id: number) => `/referral/ReferralBusiness/${id}`,
  EXPORT_REFERRAL_BUSINESS: "/referral/ReferralBusiness/Export",
  ADD_REFERRAL_BUSINESS : "referral/ReferralBusiness/ReferralBusiness",
  UPDATE_REFERRAL_BUSINESS : "referral/ReferralBusiness"
};

const Referrals = async (data: any): Promise<ApiResponse<any>> => {
  const payload = {
    From: data.from,
    Search: data.search,
    fromDate: data.fromDate,
    StatusIds: data.statusIds,
    To: data.to,
    ToDate: data.toDate,
    UserStatus: data.userStatus,
  };
  const res = await referralRequest.post<ApiResponse<any>>(
    `${ENDPOINTS.MY_REFERRALS}`,
    payload,
  );
  return res.data;
};

const getReferralDetailById = async (id: number) => {
  const res = await referralRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.MY_REFERRAL_DETAIL_BY_ID(id)}`,
  );
  return res.data;
};

const deleteReferralById = async (id: number) => {
  const res = await referralRequest.delete<ApiResponse<any>>(
    `${ENDPOINTS.MY_REFERRAL_DELETE(id)}`,
  );
  return res.data;
};

const updateReferral = async (referralData: any) => {
  const id = referralData?.ReferralUser?.Id;
  const res = await referralRequest.put<ApiResponse<any>>(
    ENDPOINTS.UPDATE_REFRRAL(id),
    referralData,
  );
  return res.data;
};

const addReferral = async (referralData: any) => {
  const res = await referralRequest.post<ApiResponse<any>>(
    ENDPOINTS.ADD_REFRRAL,
    referralData,
  );
  return res;
};

const approvalReferral = async (payload: any) => {
  const res = await referralRequest.get<ApiResponse<any>>(
    ENDPOINTS.APPROVE_REFERRAL(payload.userId),
    { params: payload },
  );
  return res;
};

export const ExportReferralReport = async (payload: any): Promise<any> => {
  const res = await referralRequest.post<ApiResponse<any>>(
    `${ENDPOINTS.EXPORT_REFERRAL}`,
    payload,
    {
      responseType: "arraybuffer",
    },
  );
  saveAsExcelFile(res, "Referrals");
//   return res.data;
};

const referralBusiness = async (
  payload: ReferralPayload,
): Promise<ApiResponse<ReferralBusinessResponse>> => {
  const res = await referralRequest.post<ApiResponse<ReferralBusinessResponse>>(
    `${ENDPOINTS.REFERRAL_BUSINESS}`,
    payload,
  );
  return res.data;
};

const leadList = async (
  payload: any,
): Promise<ApiResponse<LeadListResponse>> => {
  const res = await privateRequest.post<ApiResponse<LeadListResponse>>(
    `${ENDPOINTS.LEADS}`,
    payload,
  );
  return res.data;
};

const referralUsers = async (): Promise<
  ApiResponse<ReferralUserListResponse>
> => {
  const res = await referralRequest.get<ApiResponse<ReferralUserListResponse>>(
    `${ENDPOINTS.REFERRAL_USER_LIST}`,
  );
  return res.data;
};

const acceptRejectStatus = async (payload: any) => {
  const res = await referralRequest.post<ApiResponse<any>>(
    ENDPOINTS.ACCEPT_REJECT_STATUS(payload.leadId),
    payload,
  );
  return res.data;
};

export const deleteBusinessReferral = async (id: number) => {
  const res = await referralRequest.delete<ApiResponse<any>>(
    ENDPOINTS.DELETE_BUSINESS_REFERRAL(id),
  );
  return res.data;
};

export const exportReferralBusinessInExcel = async (
  payload: any,
): Promise<any> => {
  const res = await referralRequest.post<ApiResponse<any>>(
    `${ENDPOINTS.EXPORT_REFERRAL_BUSINESS}`,
    payload,
    {
      responseType: "arraybuffer",
    },
  );
  saveAsExcelFile(res, "Referral_Business");
};

const addReferralBuisness = async (referralBuisnessData: any) => {
  const res = await referralRequest.post<ApiResponse<any>>(
    ENDPOINTS.ADD_REFERRAL_BUSINESS,
    referralBuisnessData,
  );
  return res;
};

const updateReferralBusiness = async (referralData: any) => {
  const id = referralData?.id;
  const res = await referralRequest.post<ApiResponse<any>>(
    `${ENDPOINTS.UPDATE_REFERRAL_BUSINESS}/${id}`,
    referralData,
  );
  return res.data;
};

//leadList
const ReferralService = {
  Referrals,
  getReferralDetailById,
  deleteReferralById,
  updateReferral,
  addReferral,
  approvalReferral,
  ExportReferralReport,
  referralBusiness,
  leadList,
  referralUsers,
  acceptRejectStatus,
  deleteBusinessReferral,
  exportReferralBusinessInExcel,
  addReferralBuisness,
  updateReferralBusiness
};

export default ReferralService;
